function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 text-center p-4 mt-auto shadow-inner">
      <p className="text-sm">© 2025 Poultry Management System. All rights reserved.</p>
    </footer>
  );
}

export default Footer;